import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { PageName } from '@whitbread-eos/api';
import { renderSanitizedHtml, formatAssetsUrl } from '@whitbread-eos/utils';
import { useState, useEffect } from 'react';
import { Alert, Info } from '../../assets/icons';
import Icon from '../Icon';
import Notification from '../Notification';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function hasMatchingPromotionCode(promoCode, roomrates) {
  if (!promoCode || !Array.isArray(roomrates)) return false;
  return roomrates === null || roomrates === void 0 ? void 0 : roomrates.some(item => (item === null || item === void 0 ? void 0 : item.promotionCode) === promoCode);
}
export default function PromotionsNotification(_ref) {
  var _promotionBannerData$, _promotionBannerData$2, _promotionBannerData$3;
  var promotionBannerData = _ref.promotionBannerData,
    _ref$viewType = _ref.viewType,
    viewType = _ref$viewType === void 0 ? '' : _ref$viewType,
    roomRates = _ref.roomRates,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? '' : _ref$page,
    _ref$elementName = _ref.elementName,
    elementName = _ref$elementName === void 0 ? '' : _ref$elementName;
  var _ref2 = promotionBannerData || {},
    enabled = _ref2.showPromo,
    expired = _ref2.promoExpiredMessage,
    invalid = _ref2.promoInvalidMessage,
    backgroundColor = _ref2.promoBannerColour,
    icon = _ref2.promoBannerIcon,
    title = _ref2.promoBannerTitle,
    description = _ref2.promoBannerSubtitle,
    withinWindow = _ref2.isWithinPromoWindow,
    promoCode = _ref2.promotionCode,
    promoBannerVisibilityPages = _ref2.promoBannerVisibility;
  var amendMessage = (_promotionBannerData$ = promotionBannerData === null || promotionBannerData === void 0 ? void 0 : promotionBannerData.promoAmendMessage) !== null && _promotionBannerData$ !== void 0 ? _promotionBannerData$ : null;
  var amendPromoCode = (_promotionBannerData$2 = promotionBannerData === null || promotionBannerData === void 0 || (_promotionBannerData$3 = promotionBannerData.promoBookingInfo) === null || _promotionBannerData$3 === void 0 ? void 0 : _promotionBannerData$3.promotionCode) !== null && _promotionBannerData$2 !== void 0 ? _promotionBannerData$2 : null;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hasCellCodes = _useState2[0],
    setHasCellCode = _useState2[1];
  useEffect(() => {
    if (typeof window !== 'undefined') {
      var params = new URLSearchParams(window.location.search);
      setHasCellCode(params.has('CELLCODES') || params.has('CORPID'));
    }
  }, []);
  var isBannerEnabled = !invalid && !expired && (viewType === 'banner' || viewType === 'any') && withinWindow;
  var isWarningEnabled = (viewType === 'warning' || viewType === 'any') && (invalid || expired);
  var shouldPromoInfoDisplay = !hasCellCodes && enabled && (isBannerEnabled || isWarningEnabled);
  var restrictedPages = [PageName.HDP];
  var renderPromoBannerStayDates = () => {
    return amendPromoCode && enabled && !withinWindow ? _jsx(Box, {
      "data-testid": "stayDatesPromoBanner",
      children: _jsx(Notification, {
        variant: "info",
        status: "info",
        description: amendMessage,
        svg: _jsx(Info, {}),
        isInnerHTML: true,
        wrapperStyles: amendNotificationWrapperStyles,
        prefixDataTestId: "amendPromoBannerWarning"
      })
    }) : null;
  };
  if (PageName.AMEND && elementName === PageName.STAY_DATES) {
    return renderPromoBannerStayDates();
  }
  var showPromoBannerRoomsAndGuests = () => {
    return amendPromoCode && enabled ? _jsx(Box, {
      "data-testid": "roomsAndGuestsPromoBanner",
      children: _jsx(Notification, {
        variant: "info",
        status: "info",
        description: amendMessage,
        svg: _jsx(Info, {}),
        isInnerHTML: true,
        wrapperStyles: amendNotificationWrapperStyles,
        prefixDataTestId: "amendPromoBannerWarning"
      })
    }) : null;
  };
  if (PageName.AMEND && elementName === PageName.ROOMS_AND_GUESTS) {
    return showPromoBannerRoomsAndGuests();
  }
  if (shouldPromoInfoDisplay === true && roomRates && (roomRates === null || roomRates === void 0 ? void 0 : roomRates.length) > 0) {
    var hasMatchingPromotionCodes = hasMatchingPromotionCode(promoCode, roomRates);
    if (!hasMatchingPromotionCodes) shouldPromoInfoDisplay = false;
  }
  if (shouldPromoInfoDisplay && promoBannerVisibilityPages !== null && ((promoBannerVisibilityPages === null || promoBannerVisibilityPages === void 0 ? void 0 : promoBannerVisibilityPages.length) === 0 || promoBannerVisibilityPages !== null && promoBannerVisibilityPages !== void 0 && promoBannerVisibilityPages.includes(page))) {
    return _jsxs(Box, _objectSpread(_objectSpread({
      "data-testid": "PromoContainer"
    }, containerStyles()), {}, {
      children: [isBannerEnabled && _jsx(Box, _objectSpread(_objectSpread({}, getBannerContainerStyles(backgroundColor, viewType)), {}, {
        children: _jsxs(Flex, _objectSpread(_objectSpread({}, bannerTitleStyles(viewType)), {}, {
          children: [_jsxs(Flex, _objectSpread(_objectSpread({}, bannerIconTitleWrapperStyles), {}, {
            children: [_jsx(Icon, _objectSpread({
              src: formatAssetsUrl(icon)
            }, bannerIconStyles)), _jsx(Text, _objectSpread(_objectSpread({}, bannerTitleTextStyles), {}, {
              children: renderSanitizedHtml(title)
            }))]
          })), !restrictedPages.includes(page) && description && _jsx(Flex, _objectSpread(_objectSpread({}, bannerDescriptionWrapperStyles), {}, {
            children: _jsx(Text, _objectSpread(_objectSpread({}, bannerDescriptionTextStyles), {}, {
              children: renderSanitizedHtml(description)
            }))
          }))]
        }))
      })), isWarningEnabled ? _jsx(Notification, {
        variant: "alert",
        status: "warning",
        description: invalid || expired,
        svg: _jsx(Alert, {}),
        isInnerHTML: true,
        wrapperStyles: notificationWrapperStyles,
        style: notificationTextStyles,
        prefixDataTestId: "promoBannerWarning"
      }) : null]
    }));
  }
  return null;
}
var notificationWrapperStyles = {
  marginTop: {
    base: 'md',
    md: 'lg'
  },
  zIndex: '1',
  w: '100vw',
  maxW: '100%',
  position: 'relative',
  left: '50%',
  transform: 'translateX(-50%)'
};
var containerStyles = () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: 'full',
  position: 'relative',
  bg: 'white',
  marginTop: {
    base: 'md',
    md: 'lg'
  }
});
var getBannerContainerStyles = (bgColor, viewType) => ({
  backgroundColor: bgColor,
  display: 'grid',
  gridTemplateColumns: {
    base: '1fr'
  },
  p: '0.75rem 1rem',
  w: {
    mobile: 'full',
    md: '45rem',
    lg: '50.5rem',
    xl: viewType === 'any' ? '100%' : '54rem'
  },
  borderRadius: viewType === 'warning' ? 0 : '8px',
  lineHeight: '120%',
  minH: 'full',
  alignItems: 'center'
});
var bannerTitleStyles = viewType => ({
  display: 'flex',
  gap: '2px',
  fontSize: 'lg',
  align: 'center',
  alignItems: {
    base: viewType === 'any' ? 'center' : 'flex-start'
  },
  flexWrap: viewType === 'any' ? 'wrap' : 'nowrap',
  flexDirection: {
    base: viewType === 'any' ? 'row' : 'column'
  },
  lineHeight: '120%',
  minH: {
    base: '2.5625rem'
  },
  justifyContent: {
    base: viewType === 'any' ? 'left' : 'center'
  }
});
var bannerIconTitleWrapperStyles = {
  align: 'center'
};
var bannerIconStyles = {
  display: 'inline',
  width: '1rem',
  height: '1rem',
  marginRight: '0.375rem'
};
var bannerTitleTextStyles = {
  as: 'span',
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'white'
};
var bannerDescriptionWrapperStyles = {
  alignItems: 'center'
};
var bannerDescriptionTextStyles = {
  as: 'span',
  color: 'white',
  fontSize: 'sm',
  fontWeight: 'normal',
  ml: {
    base: 0,
    md: '6px'
  },
  alignItems: 'center'
};
var notificationTextStyles = {
  fontSize: '1rem',
  lineHeight: '1.5rem',
  fontWeight: 'normal',
  border: 0,
  color: 'darkGrey1'
};
var amendNotificationWrapperStyles = {
  marginTop: {
    base: 'md',
    md: 'lg'
  },
  zIndex: '1',
  w: 'auto'
};